import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import Box from "../../../../components/Box";
import { Helpers } from "../../../../helpers/Helpers";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../../_metronic/layout/core";
import { storeActivityIndicator } from "../../../../redux/reducers/authSlice";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomNumberInput from "../../../../components/CustomNumberInput";
import CustomTextInput from "../../../../components/CustomTextInput";
import CustomDatePicker from "../../../../components/CustomDatePicker";
import { HGS_SAYFASI, HgsKaydi, HgsOgsService, HgsSecenekleri, ISLEM_TURU, tutarYaz } from "../../../../services/HgsOgsService";

const bugun = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/**
 * Genel Giderler > HGS Kayıtları > kayıt (26.10.2026, #100). Araç listesinde Treyler / Yarı Römork yok; araç cinsi
 * seçilen araçtan gelir. Giriş Yeri yalnız "Geçiş" türünde zorunlu; çıkış, işletme (otoyol) ve geçiş türü isteğe bağlı.
 * Yükleme (bakiye yükleme) maliyete girmez. İşlem tarihi = giriş tarihi; TL karşılığı o günün döviz alış kuruyla hesaplanır.
 * Sefer seçimi isteğe bağlı (Nakliye seferi).
 */
const HgsOgsAdd = () => {
    const navigate = useNavigate();
    const pageName = HGS_SAYFASI
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [secenekler, setSecenekler] = useState<HgsSecenekleri | undefined>(undefined);
    const [kayitId, setKayitId] = useState<string | undefined>(undefined);
    const [kayit, setKayit] = useState<HgsKaydi | undefined>(undefined);
    const [islemTuru, setIslemTuru] = useState<CustomSingleSelectModel | undefined>({ label: 'Geçiş', value: String(ISLEM_TURU.GECIS) });
    const [arac, setArac] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [islemTarihi, setIslemTarihi] = useState<string | undefined>(bugun());
    const [islemSaati, setIslemSaati] = useState<string>('');
    const [girisYeri, setGirisYeri] = useState<string | undefined>(undefined);
    const [cikisTarihi, setCikisTarihi] = useState<string | undefined>(undefined);
    const [cikisSaati, setCikisSaati] = useState<string>('');
    const [cikisYeri, setCikisYeri] = useState<string | undefined>(undefined);
    const [isletme, setIsletme] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [gecisTuru, setGecisTuru] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [tutar, setTutar] = useState<string | undefined>(undefined);
    const [doviz, setDoviz] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [sefer, setSefer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [etiketNo, setEtiketNo] = useState<string | undefined>(undefined);
    const [aciklama, setAciklama] = useState<string | undefined>(undefined);

    const tur = Number(islemTuru?.value ?? ISLEM_TURU.GECIS);
    const gecis = tur == ISLEM_TURU.GECIS;

    useEffect(() => {
        baslat(searchParams.get('id'));
    }, [])

    const baslat = async (id: string | null) => {
        try {
            dispatch(storeActivityIndicator(true));

            var s = await HgsOgsService.secenekler();

            if (!s.isSuccess) {
                toast.error(s.message ?? '');
                return;
            }

            const sec = s.data as HgsSecenekleri;
            setSecenekler(sec);

            if (!id) {
                const tl = sec.dovizCinsleri.find(x => x.value == sec.varsayilanDovizId);
                if (tl)
                    setDoviz({ label: tl.label, value: tl.value });
                return;
            }

            var response = await HgsOgsService.getById(id);

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                return;
            }

            const k = response.data as HgsKaydi;
            setKayitId(k.hgsOgsKaydiId);
            setKayit(k);
            setIslemTuru({ label: k.islemTuruAdi, value: String(k.islemTuru) });
            setArac({ label: k.plaka ?? k.hamPlaka ?? '', value: k.vehicleId, additionalValue1: k.aracCinsi });
            setIslemTarihi(k.islemTarihiDeger);
            setIslemSaati(k.islemSaati ?? '');
            setGirisYeri(k.girisYeri ?? undefined);
            setCikisTarihi(k.cikisTarihiDeger ?? undefined);
            setCikisSaati(k.cikisSaati ?? '');
            setCikisYeri(k.cikisYeri ?? undefined);
            setIsletme(k.isletmeId ? { label: k.isletme ?? '', value: k.isletmeId } : undefined);
            setGecisTuru(k.gecisTuruId ? { label: k.gecisTuru ?? '', value: k.gecisTuruId } : undefined);
            setTutar(String(k.tutar));
            setDoviz({ label: k.dovizCinsi ?? '', value: k.currencyTypeId });
            setSefer(k.seferId ? { label: k.seferNo ?? '', value: k.seferId } : undefined);
            setEtiketNo(k.etiketNo ?? undefined);
            setAciklama(k.aciklama ?? undefined);
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const liste = (al: (s: HgsSecenekleri) => { value: number | string, label: string }[]) =>
        () => Promise.resolve({ isSuccess: true, data: secenekler ? al(secenekler).map(x => ({ label: x.label, value: String(x.value) })) : [] });

    const kaydet = async () => {
        const eksik: string[] = [];
        if (!arac) eksik.push('Araç Plaka');
        if (!islemTarihi) eksik.push('Giriş Tarihi');
        if (gecis && Helpers.isEmpty(girisYeri)) eksik.push('Giriş Yeri');
        if (Helpers.isEmpty(tutar)) eksik.push('Ücret');
        if (!doviz) eksik.push('Döviz Cinsi');

        if (eksik.length > 0) {
            toast.error('Zorunlu alanları doldurun: ' + eksik.join(', '));
            return;
        }

        if (islemTarihi! > bugun()) {
            toast.error('Giriş tarihi ileri bir tarih olamaz.');
            return;
        }

        // Çıkış saati var, tarihi yoksa giriş günü sayılır (sunucu da aynı kuralı uygular).
        const cikisGunu = cikisTarihi || (cikisSaati ? islemTarihi : undefined);
        if (cikisGunu && (cikisGunu < islemTarihi! || (cikisGunu == islemTarihi && islemSaati && cikisSaati && cikisSaati < islemSaati))) {
            toast.error('Çıkış zamanı girişten önce olamaz.');
            return;
        }

        const sayi = Number(tutar);
        if (isNaN(sayi) || (tur == ISLEM_TURU.DUZELTME ? sayi == 0 : sayi <= 0)) {
            toast.error(tur == ISLEM_TURU.DUZELTME ? 'Düzeltme tutarı sıfır olamaz.' : 'Ücret sıfırdan büyük olmalı.');
            return;
        }

        try {
            dispatch(storeActivityIndicator(true));

            var response = await HgsOgsService.kaydet({
                id: kayitId,
                islemTuru: tur,
                vehicleId: arac?.value,
                islemTarihi: islemTarihi,
                islemSaati: islemSaati || undefined,
                girisYeri: girisYeri,
                cikisTarihi: cikisTarihi || undefined,
                cikisSaati: cikisSaati || undefined,
                cikisYeri: cikisYeri,
                isletmeId: isletme?.value,
                gecisTuruId: gecisTuru?.value,
                tutar: sayi,
                currencyTypeId: doviz?.value,
                seferId: sefer?.value,
                etiketNo: etiketNo,
                aciklama: aciklama
            });

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                return;
            }

            const k = response.data as HgsKaydi;
            toast.success('Kayıt kaydedildi.');
            setKayitId(k.hgsOgsKaydiId);
            setKayit(k);
            setEtiketNo(k.etiketNo ?? undefined);

            if (!kayitId)
                navigate('/hgsogs/listadd?id=' + k.hgsOgsKaydiId, { replace: true });
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <KTCard className="ebbe-card">
                        <KTCardBody>
                            <h4 className="mb-10 text-black">Araç</h4>

                            <div className="row">
                                <div className="col-md-3">
                                    <CustomSingleSelect
                                        labelText="İşlem Türü"
                                        isLabelRequired
                                        selectedValue={islemTuru}
                                        onChange={(v) => setIslemTuru(v ?? { label: 'Geçiş', value: String(ISLEM_TURU.GECIS) })}
                                        onMenuOpen={liste(s => s.islemTurleri)}
                                        labelName='label'
                                        valueName='value'
                                    />
                                </div>

                                <div className="col-md-3">
                                    <CustomSingleSelect
                                        labelText="Araç Plaka"
                                        isLabelRequired
                                        selectedValue={arac}
                                        onChange={(v) => { setArac(v); setSefer(undefined); }}
                                        onMenuOpen={() => HgsOgsService.plakalar()}
                                        labelName='label'
                                        valueName='value'
                                        additionalValue1Name='ek'
                                        isOrdering
                                    />
                                </div>

                                <div className="col-md-3">
                                    <CustomTextInput labelText="Araç Cinsi" isDisabled value={arac?.additionalValue1 ?? ''} />
                                </div>

                                <div className="col-md-3">
                                    <CustomTextInput labelText="Etiket No (boş = araç kartındaki)" value={etiketNo} setValue={setEtiketNo} />
                                </div>
                            </div>
                        </KTCardBody>
                    </KTCard>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <h4 className="mb-10 text-black">Geçiş</h4>

                            <div className="row">
                                <div className="col-md-3">
                                    <CustomDatePicker labelText="Giriş Tarihi" isLabelRequired value={islemTarihi} setValue={setIslemTarihi} />
                                </div>

                                <div className="col-md-2">
                                    <label className="form-label">Giriş Saati</label>
                                    <input
                                        id="hgs-giris-saati"
                                        type="time"
                                        step={1}
                                        value={islemSaati}
                                        onChange={(e) => setIslemSaati(e.target.value)}
                                        style={{ border: '1px solid #F1F1F4' }}
                                        className="form-control form-control-solid"
                                    />
                                </div>

                                <div className="col-md-4">
                                    <CustomTextInput labelText="Giriş Yeri" isLabelRequired={gecis} value={girisYeri} setValue={setGirisYeri} />
                                </div>
                            </div>

                            <div className="row mt-5">
                                <div className="col-md-3">
                                    <CustomDatePicker labelText="Çıkış Tarihi" value={cikisTarihi} setValue={setCikisTarihi} />
                                </div>

                                <div className="col-md-2">
                                    <label className="form-label">Çıkış Saati</label>
                                    <input
                                        id="hgs-cikis-saati"
                                        type="time"
                                        step={1}
                                        value={cikisSaati}
                                        onChange={(e) => setCikisSaati(e.target.value)}
                                        style={{ border: '1px solid #F1F1F4' }}
                                        className="form-control form-control-solid"
                                    />
                                </div>

                                <div className="col-md-4">
                                    <CustomTextInput labelText="Çıkış Yeri" value={cikisYeri} setValue={setCikisYeri} />
                                </div>
                            </div>

                            <div className="row mt-5">
                                <div className="col-md-5">
                                    <CustomSingleSelect
                                        labelText="İşletme / Otoyol"
                                        selectedValue={isletme}
                                        onChange={setIsletme}
                                        onMenuOpen={liste(s => s.isletmeler)}
                                        labelName='label'
                                        valueName='value'
                                    />
                                </div>

                                <div className="col-md-4">
                                    <CustomSingleSelect
                                        labelText="Geçiş Türü"
                                        selectedValue={gecisTuru}
                                        onChange={setGecisTuru}
                                        onMenuOpen={liste(s => s.gecisTurleri)}
                                        labelName='label'
                                        valueName='value'
                                    />
                                </div>
                            </div>

                            <div className="text-muted fs-7 mt-3">Köprü ve tek gişeli geçişlerde çıkış, girişle aynıdır; boş bırakılabilir. Maliyet ve kur tarihi giriş tarihidir.</div>

                            <div className="row mt-5">
                                <div className="col-md-3">
                                    <CustomNumberInput labelText={tur == ISLEM_TURU.DUZELTME ? 'Tutar (eksi olabilir)' : 'Ücret'} isLabelRequired value={tutar} setValue={setTutar} allowNegative={tur == ISLEM_TURU.DUZELTME} />
                                </div>

                                <div className="col-md-2">
                                    <CustomSingleSelect
                                        labelText="Döviz Cinsi"
                                        isLabelRequired
                                        selectedValue={doviz}
                                        onChange={setDoviz}
                                        onMenuOpen={liste(s => s.dovizCinsleri)}
                                        labelName='label'
                                        valueName='value'
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">TL Karşılığı</label>
                                    <div className="form-control form-control-solid" style={{ background: '#f1f1f4', border: '1px solid #F1F1F4' }}>
                                        {kayit ? `${tutarYaz(kayit.tutarTL)} TL` : '—'}
                                    </div>
                                    <div className="text-muted fs-8 mt-1">
                                        {kayit && kayit.kur != 1 ? `Kur ${kayit.kur.toLocaleString('tr-TR', { maximumFractionDigits: 6 })} (giriş tarihi döviz alış). ` : ''}Kaydedince giriş tarihinin kuruyla hesaplanır.
                                    </div>
                                </div>
                            </div>

                            {
                                tur == ISLEM_TURU.YUKLEME && (
                                    <div className="text-muted fs-7 mt-5">Yükleme (bakiye yükleme) kaydı tutulur ama araç ve sefer maliyetine girmez; maliyete geçişler girer.</div>
                                )
                            }
                            {
                                tur == ISLEM_TURU.IADE && (
                                    <div className="text-muted fs-7 mt-5">İade tutarı maliyetten düşülür.</div>
                                )
                            }
                        </KTCardBody>
                    </KTCard>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <h4 className="mb-10 text-black">Sefer ve Açıklama</h4>

                            <div className="row">
                                <div className="col-md-4">
                                    <CustomSingleSelect
                                        labelText="Sefer No (Nakliye)"
                                        selectedValue={sefer}
                                        onChange={setSefer}
                                        onMenuOpen={(arama) => HgsOgsService.seferler(arac?.value, arama)}
                                        labelName='label'
                                        valueName='value'
                                        isPaging
                                        placeholder="Seçilen aracın seferleri üstte"
                                    />
                                </div>

                                <div className="col-md-8">
                                    <CustomTextInput labelText="Açıklama" value={aciklama} setValue={setAciklama} />
                                </div>
                            </div>
                        </KTCardBody>
                    </KTCard>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">
                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={kaydet}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default HgsOgsAdd;
